import { render } from "./SiteMenu.vue?vue&type=template&id=e8c677fa"
import script from "./SiteMenu.vue?vue&type=script&lang=js"
export * from "./SiteMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__